import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import ArtworkExcerpt from './ArtworkExcerpt';
import { isPremiumOption } from '../../utils/isPremium';
import generateNameForOption from '../../utils/generateDispalyedName';
import layout from '../../styles/layout.module.css';
import typography from '../../styles/typography.module.css';
import { isDisabled } from '../../utils/isDisabled';

export const ArtworkList = () => {
    const iem = useSelector((state) => state.rootReducer.currentModel.currentModel);
    // const dispatch = useDispatch();
    const artwork = iem.artwork;
    const currentSide = useSelector((state) => state.rootReducer.settingsOptions.currentSide);
    const currentArtwork = useSelector((state) => state.rootReducer.currentArtwork);
    const faceplate = useSelector((state) => state.rootReducer.currentFaceplateOption);

    const [selected, setSelected] = useState(null);

    const displayedName = useMemo(() => {
        let isArtworkDisabled = isDisabled(currentSide, faceplate);
        if (isArtworkDisabled) {
            return 'Custom Artwork is not available for this option';
        }
        if (currentSide === 'both') {
            return generateNameForOption(currentArtwork.leftArtwork);
        } else if (currentSide === 'left') {
            return generateNameForOption(currentArtwork.leftArtwork);
        } else {
            return generateNameForOption(currentArtwork.rightArtwork);
        }
    }, [currentSide, currentArtwork, selected]);

    const generateArtwork = (artwork, disabled) => {
        let options = Object.keys(artwork);
        return options.map((val, index) => (
            <ArtworkExcerpt
                faceplate={faceplate}
                key={index}
                selected={selected}
                setSelected={setSelected}
                artwork={artwork[val]}
                isCurrent={generateNameForOption(artwork[val]) === displayedName}
                currentSide={currentSide}
                disabled={disabled}
            />
        ));
    };

    let content;
    let artworkPicker;
    if (currentSide === 'both') {
        if (!isPremiumOption(faceplate.leftOption) && !isPremiumOption(faceplate.rightOption)) {
            artworkPicker = generateArtwork(artwork, false);
        } else if (
            isPremiumOption(faceplate.leftOption) &&
            !isPremiumOption(faceplate.rightOption)
        ) {
            artworkPicker = generateArtwork(artwork, false);
        } else if (
            !isPremiumOption(faceplate.leftOption) &&
            isPremiumOption(faceplate.rightOption)
        ) {
            artworkPicker = generateArtwork(artwork, false);
        } else {
            artworkPicker = generateArtwork(artwork, true);
        }
    } else if (currentSide === 'left') {
        if (!isPremiumOption(faceplate.leftOption)) {
            artworkPicker = generateArtwork(artwork, false);
        } else {
            artworkPicker = generateArtwork(artwork, true);
        }
    } else {
        if (!isPremiumOption(faceplate.rightOption)) {
            artworkPicker = generateArtwork(artwork, false);
        } else {
            artworkPicker = generateArtwork(artwork, true);
        }
    }
    content = (
        <Box className={layout.subSectionContainer}>
            <h4 className={typography.headerTitle}>
                {selected !== null ? selected : displayedName}
            </h4>
            <Box className={layout.sliderContainer}>{artworkPicker}</Box>
        </Box>
    );

    return <>{content}</>;
};
